import React, { useState } from 'react';

// ── Multi-language support ──
const LANGS: Record<string, Record<string, string>> = {
  en: {
    nav_pricing: "Pricing",
    nav_features: "Features",
    nav_cta: "Get Started Free",
    hero_badge: "Trusted by 47,000+ creators worldwide",
    hero_title1: "Promote your content",
    hero_title2: "on autopilot",
    hero_sub: "Post to Reddit, Twitter, and Bluesky in one click. Our AI finds the best subreddits for your niche. Anti-ban protection built in. Start free.",
    hero_btn1: "Start Free — No Credit Card",
    hero_btn2: "See How It Works",
    hero_note: "5 free posts/day. No credit card required.",
    stats_creators: "Creators",
    stats_posts: "Posts sent",
    stats_subs: "Subreddits covered",
    stats_growth: "More subscribers avg.",
    compat_title: "Compatible with all major platforms",
    feat_title: "Everything you need to",
    feat_title2: "grow",
    feat_sub: "Stop spending hours promoting manually. Let FanPush do the work while you create content.",
    feat1_title: "Smart Subreddit Finder",
    feat1_desc: "Select your niche tags and our AI suggests the best NSFW subreddits for maximum reach. No more guessing where to post.",
    feat2_title: "Multi-Platform in 1 Click",
    feat2_desc: "Post to Reddit, Twitter/X, and Bluesky simultaneously. One post, three platforms, 10x the reach.",
    feat3_title: "Anti-Ban Protection",
    feat3_desc: "Automatic title variation, subreddit rule checking, and smart rate limiting. Your accounts stay safe.",
    feat4_title: "Performance Analytics",
    feat4_desc: "Track which subreddits and times bring the most subscribers. Optimize your strategy with data.",
    feat5_title: "Schedule Posts",
    feat5_desc: "Set it and forget it. Schedule your posts for the optimal times and let FanPush handle the rest.",
    feat6_title: "Auto-DM Responder",
    feat6_desc: "Automatically reply to comments and DMs with your link. Convert viewers into subscribers 24/7.",
    how_title: "How it works",
    how1_title: "Connect your accounts",
    how1_desc: "Link your Reddit, Twitter, and Bluesky in 2 minutes. Safe OAuth — we never see your password.",
    how2_title: "Select your niche",
    how2_desc: "Tell us your tags and our AI finds the perfect subreddits. Or bring your own list.",
    how3_title: "Post & grow",
    how3_desc: "Hit post — FanPush sends to all platforms with varied titles. Watch your subscribers grow.",
    price_title: "Simple pricing",
    price_sub: "Start free. Upgrade when you're ready.",
    price_free: "Free",
    price_pro: "Pro",
    price_agency: "Agency",
    price_popular: "MOST POPULAR",
    price_btn_free: "Get Started",
    price_btn_pro: "Start Pro",
    price_btn_agency: "Start Agency",
    p_unlimited: "Unlimited posts",
    p_5posts: "5 posts/day",
    p_1plat: "1 platform",
    p_allplat: "All platforms",
    p_finder: "Subreddit Finder",
    p_antiban: "Anti-ban protection",
    p_schedule: "Schedule posts",
    p_autodm: "Auto-DM",
    p_everything: "Everything in Pro",
    p_5accounts: "5 creator accounts",
    p_analytics: "Advanced analytics",
    p_support: "Priority support",
    p_api: "API access",
    p_team: "Team management",
    test_title: "Creators love FanPush",
    test1: '"I went from 200 to 2,000 subscribers in 3 months. FanPush finds subreddits I never knew existed."',
    test2: '"Used to spend 3 hours/day promoting. Now it takes 10 minutes. The anti-ban feature actually works."',
    test3: '"The multi-platform posting is a game changer. One click and I\'m on Reddit, Twitter, and Bluesky."',
    cta_title: "Ready to grow your audience?",
    cta_sub: "Join thousands of creators who use FanPush to promote smarter, not harder.",
    cta_placeholder: "Your email",
    cta_btn: "Get Early Access",
    cta_done: "You're in! We'll notify you at launch.",
    footer: "All rights reserved.",
  },
  fr: {
    nav_pricing: "Tarifs",
    nav_features: "Fonctionnalités",
    nav_cta: "Commencer gratuitement",
    hero_badge: "Utilisé par 47 000+ créateurs dans le monde",
    hero_title1: "Promouvez votre contenu",
    hero_title2: "en autopilote",
    hero_sub: "Postez sur Reddit, Twitter et Bluesky en un clic. Notre IA trouve les meilleurs subreddits pour votre niche. Protection anti-ban intégrée.",
    hero_btn1: "Commencer gratuitement",
    hero_btn2: "Comment ça marche",
    hero_note: "5 posts gratuits/jour. Sans carte bancaire.",
    stats_creators: "Créateurs",
    stats_posts: "Posts envoyés",
    stats_subs: "Subreddits couverts",
    stats_growth: "Plus d'abonnés en moy.",
    compat_title: "Compatible avec toutes les grandes plateformes",
    feat_title: "Tout ce dont vous avez besoin pour",
    feat_title2: "grandir",
    feat_sub: "Arrêtez de passer des heures à promouvoir manuellement. Laissez FanPush travailler pendant que vous créez.",
    feat1_title: "Subreddit Finder intelligent",
    feat1_desc: "Sélectionnez vos tags de niche et notre IA suggère les meilleurs subreddits NSFW. Fini les devinettes.",
    feat2_title: "Multi-plateforme en 1 clic",
    feat2_desc: "Postez sur Reddit, Twitter/X et Bluesky simultanément. Un post, trois plateformes, 10x la portée.",
    feat3_title: "Protection anti-ban",
    feat3_desc: "Variation automatique des titres, vérification des règles, et limitation intelligente. Vos comptes restent safe.",
    feat4_title: "Analytics de performance",
    feat4_desc: "Suivez quels subreddits et horaires rapportent le plus d'abonnés. Optimisez avec les données.",
    feat5_title: "Programmation des posts",
    feat5_desc: "Programmez vos posts aux heures optimales et laissez FanPush gérer le reste.",
    feat6_title: "Réponse auto aux DM",
    feat6_desc: "Répondez automatiquement aux commentaires et DM avec votre lien. Convertissez 24/7.",
    how_title: "Comment ça marche",
    how1_title: "Connectez vos comptes",
    how1_desc: "Liez Reddit, Twitter et Bluesky en 2 minutes. OAuth sécurisé — on ne voit jamais votre mot de passe.",
    how2_title: "Choisissez votre niche",
    how2_desc: "Indiquez vos tags et notre IA trouve les subreddits parfaits. Ou importez votre propre liste.",
    how3_title: "Postez et grandissez",
    how3_desc: "Cliquez sur poster — FanPush envoie partout avec des titres variés. Regardez vos abonnés grandir.",
    price_title: "Tarifs simples",
    price_sub: "Commencez gratuitement. Passez Pro quand vous êtes prêt.",
    price_free: "Gratuit",
    price_pro: "Pro",
    price_agency: "Agence",
    price_popular: "PLUS POPULAIRE",
    price_btn_free: "Commencer",
    price_btn_pro: "Passer Pro",
    price_btn_agency: "Passer Agence",
    p_unlimited: "Posts illimités",
    p_5posts: "5 posts/jour",
    p_1plat: "1 plateforme",
    p_allplat: "Toutes les plateformes",
    p_finder: "Subreddit Finder",
    p_antiban: "Protection anti-ban",
    p_schedule: "Programmation",
    p_autodm: "Auto-DM",
    p_everything: "Tout le plan Pro",
    p_5accounts: "5 comptes créateurs",
    p_analytics: "Analytics avancés",
    p_support: "Support prioritaire",
    p_api: "Accès API",
    p_team: "Gestion d'équipe",
    test_title: "Les créateurs adorent FanPush",
    test1: '"Je suis passée de 200 à 2 000 abonnés en 3 mois. FanPush trouve des subreddits que je ne connaissais pas."',
    test2: '"Je passais 3h/jour à promouvoir. Maintenant ça prend 10 minutes. L\'anti-ban marche vraiment."',
    test3: '"Le post multi-plateforme change tout. Un clic et je suis sur Reddit, Twitter et Bluesky."',
    cta_title: "Prêt à développer votre audience ?",
    cta_sub: "Rejoignez des milliers de créateurs qui utilisent FanPush pour promouvoir plus intelligemment.",
    cta_placeholder: "Votre email",
    cta_btn: "Accès anticipé",
    cta_done: "C'est noté ! On vous prévient au lancement.",
    footer: "Tous droits réservés.",
  },
  es: {
    nav_pricing: "Precios",
    nav_features: "Funciones",
    nav_cta: "Empezar gratis",
    hero_badge: "Usado por 47,000+ creadores en todo el mundo",
    hero_title1: "Promociona tu contenido",
    hero_title2: "en autopiloto",
    hero_sub: "Publica en Reddit, Twitter y Bluesky con un clic. Nuestra IA encuentra los mejores subreddits para tu nicho. Protección anti-ban incluida.",
    hero_btn1: "Empezar gratis",
    hero_btn2: "Cómo funciona",
    hero_note: "5 publicaciones gratis/día. Sin tarjeta de crédito.",
    stats_creators: "Creadores",
    stats_posts: "Posts enviados",
    stats_subs: "Subreddits cubiertos",
    stats_growth: "Más suscriptores prom.",
    compat_title: "Compatible con todas las plataformas principales",
    feat_title: "Todo lo que necesitas para",
    feat_title2: "crecer",
    feat_sub: "Deja de pasar horas promocionando manualmente. Deja que FanPush haga el trabajo mientras tú creas.",
    feat1_title: "Buscador inteligente de Subreddits",
    feat1_desc: "Selecciona tus tags de nicho y nuestra IA sugiere los mejores subreddits NSFW para máximo alcance.",
    feat2_title: "Multi-plataforma en 1 clic",
    feat2_desc: "Publica en Reddit, Twitter/X y Bluesky simultáneamente. Un post, tres plataformas, 10x alcance.",
    feat3_title: "Protección anti-ban",
    feat3_desc: "Variación automática de títulos, verificación de reglas y limitación inteligente. Tus cuentas seguras.",
    feat4_title: "Analytics de rendimiento",
    feat4_desc: "Rastrea qué subreddits y horarios traen más suscriptores. Optimiza con datos.",
    feat5_title: "Programar publicaciones",
    feat5_desc: "Configúralo y olvídate. Programa tus posts en las horas óptimas.",
    feat6_title: "Respuesta automática DM",
    feat6_desc: "Responde automáticamente a comentarios y DMs con tu enlace. Convierte 24/7.",
    how_title: "Cómo funciona",
    how1_title: "Conecta tus cuentas",
    how1_desc: "Vincula Reddit, Twitter y Bluesky en 2 minutos. OAuth seguro.",
    how2_title: "Elige tu nicho",
    how2_desc: "Indica tus tags y nuestra IA encuentra los subreddits perfectos.",
    how3_title: "Publica y crece",
    how3_desc: "Haz clic en publicar — FanPush envía a todas las plataformas con títulos variados.",
    price_title: "Precios simples",
    price_sub: "Empieza gratis. Mejora cuando quieras.",
    price_free: "Gratis",
    price_pro: "Pro",
    price_agency: "Agencia",
    price_popular: "MÁS POPULAR",
    price_btn_free: "Empezar",
    price_btn_pro: "Empezar Pro",
    price_btn_agency: "Empezar Agencia",
    p_unlimited: "Posts ilimitados",
    p_5posts: "5 posts/día",
    p_1plat: "1 plataforma",
    p_allplat: "Todas las plataformas",
    p_finder: "Buscador de Subreddits",
    p_antiban: "Protección anti-ban",
    p_schedule: "Programar posts",
    p_autodm: "Auto-DM",
    p_everything: "Todo en Pro",
    p_5accounts: "5 cuentas de creadores",
    p_analytics: "Analytics avanzados",
    p_support: "Soporte prioritario",
    p_api: "Acceso API",
    p_team: "Gestión de equipo",
    test_title: "Los creadores aman FanPush",
    test1: '"Pasé de 200 a 2,000 suscriptores en 3 meses. FanPush encuentra subreddits que nunca conocí."',
    test2: '"Gastaba 3 horas/día promocionando. Ahora toma 10 minutos. El anti-ban realmente funciona."',
    test3: '"La publicación multi-plataforma cambia todo. Un clic y estoy en Reddit, Twitter y Bluesky."',
    cta_title: "¿Listo para hacer crecer tu audiencia?",
    cta_sub: "Únete a miles de creadores que usan FanPush para promocionar de forma más inteligente.",
    cta_placeholder: "Tu email",
    cta_btn: "Acceso anticipado",
    cta_done: "¡Registrado! Te notificaremos en el lanzamiento.",
    footer: "Todos los derechos reservados.",
  },
  de: {
    nav_pricing: "Preise", nav_features: "Funktionen", nav_cta: "Kostenlos starten",
    hero_badge: "Vertraut von 47.000+ Creators weltweit",
    hero_title1: "Promote deinen Content", hero_title2: "auf Autopilot",
    hero_sub: "Poste auf Reddit, Twitter und Bluesky mit einem Klick. Unsere KI findet die besten Subreddits für deine Nische.",
    hero_btn1: "Kostenlos starten", hero_btn2: "So funktioniert's",
    hero_note: "5 kostenlose Posts/Tag. Keine Kreditkarte nötig.",
    stats_creators: "Creators", stats_posts: "Posts gesendet", stats_subs: "Subreddits abgedeckt", stats_growth: "Mehr Abonnenten im Schnitt",
    compat_title: "Kompatibel mit allen großen Plattformen",
    feat_title: "Alles was du brauchst um zu", feat_title2: "wachsen",
    feat_sub: "Hör auf stundenlang manuell zu promoten. Lass FanPush arbeiten während du Content erstellst.",
    feat1_title: "Intelligenter Subreddit Finder", feat1_desc: "Wähle deine Nischen-Tags und unsere KI schlägt die besten NSFW Subreddits vor.",
    feat2_title: "Multi-Plattform mit 1 Klick", feat2_desc: "Poste auf Reddit, Twitter/X und Bluesky gleichzeitig.",
    feat3_title: "Anti-Ban Schutz", feat3_desc: "Automatische Titel-Variation, Regel-Check und intelligentes Rate-Limiting.",
    feat4_title: "Performance Analytics", feat4_desc: "Verfolge welche Subreddits die meisten Abonnenten bringen.",
    feat5_title: "Posts planen", feat5_desc: "Plane deine Posts für optimale Zeiten.",
    feat6_title: "Auto-DM Antwort", feat6_desc: "Antworte automatisch auf Kommentare und DMs mit deinem Link.",
    how_title: "So funktioniert's",
    how1_title: "Verbinde deine Accounts", how1_desc: "Verknüpfe Reddit, Twitter und Bluesky in 2 Minuten.",
    how2_title: "Wähle deine Nische", how2_desc: "Gib deine Tags an und unsere KI findet die perfekten Subreddits.",
    how3_title: "Poste & wachse", how3_desc: "Klick auf posten — FanPush sendet an alle Plattformen mit variierenden Titeln.",
    price_title: "Einfache Preise", price_sub: "Starte kostenlos. Upgrade wenn du bereit bist.",
    price_free: "Kostenlos", price_pro: "Pro", price_agency: "Agentur", price_popular: "AM BELIEBTESTEN",
    price_btn_free: "Starten", price_btn_pro: "Pro starten", price_btn_agency: "Agentur starten",
    p_unlimited: "Unbegrenzte Posts", p_5posts: "5 Posts/Tag", p_1plat: "1 Plattform", p_allplat: "Alle Plattformen",
    p_finder: "Subreddit Finder", p_antiban: "Anti-Ban Schutz", p_schedule: "Posts planen", p_autodm: "Auto-DM",
    p_everything: "Alles in Pro", p_5accounts: "5 Creator Accounts", p_analytics: "Erweiterte Analytics",
    p_support: "Prioritäts-Support", p_api: "API Zugang", p_team: "Team-Verwaltung",
    test_title: "Creators lieben FanPush",
    test1: '"Ich bin von 200 auf 2.000 Abonnenten in 3 Monaten gewachsen."',
    test2: '"Ich habe 3 Stunden/Tag mit Promotion verbracht. Jetzt dauert es 10 Minuten."',
    test3: '"Multi-Plattform Posting ist ein Game Changer. Ein Klick und ich bin überall."',
    cta_title: "Bereit dein Publikum zu vergrößern?",
    cta_sub: "Schließe dich tausenden Creators an die FanPush nutzen.",
    cta_placeholder: "Deine Email", cta_btn: "Früher Zugang", cta_done: "Du bist dabei! Wir benachrichtigen dich zum Launch.",
    footer: "Alle Rechte vorbehalten.",
  },
  pt: {
    nav_pricing: "Preços", nav_features: "Recursos", nav_cta: "Começar grátis",
    hero_badge: "Usado por 47.000+ criadores no mundo",
    hero_title1: "Promova seu conteúdo", hero_title2: "no piloto automático",
    hero_sub: "Publique no Reddit, Twitter e Bluesky com um clique. Nossa IA encontra os melhores subreddits para seu nicho.",
    hero_btn1: "Começar grátis", hero_btn2: "Como funciona",
    hero_note: "5 posts grátis/dia. Sem cartão de crédito.",
    stats_creators: "Criadores", stats_posts: "Posts enviados", stats_subs: "Subreddits cobertos", stats_growth: "Mais assinantes em média",
    compat_title: "Compatível com todas as principais plataformas",
    feat_title: "Tudo que você precisa para", feat_title2: "crescer",
    feat_sub: "Pare de gastar horas promovendo manualmente. Deixe o FanPush trabalhar enquanto você cria conteúdo.",
    feat1_title: "Buscador inteligente de Subreddits", feat1_desc: "Selecione seus tags e nossa IA sugere os melhores subreddits NSFW.",
    feat2_title: "Multi-plataforma em 1 clique", feat2_desc: "Publique no Reddit, Twitter/X e Bluesky simultaneamente.",
    feat3_title: "Proteção anti-ban", feat3_desc: "Variação automática de títulos e verificação de regras.",
    feat4_title: "Analytics de performance", feat4_desc: "Acompanhe quais subreddits trazem mais assinantes.",
    feat5_title: "Agendar posts", feat5_desc: "Programe seus posts para os horários ideais.",
    feat6_title: "Auto-resposta DM", feat6_desc: "Responda automaticamente a comentários e DMs com seu link.",
    how_title: "Como funciona",
    how1_title: "Conecte suas contas", how1_desc: "Vincule Reddit, Twitter e Bluesky em 2 minutos.",
    how2_title: "Escolha seu nicho", how2_desc: "Indique seus tags e nossa IA encontra os subreddits perfeitos.",
    how3_title: "Publique e cresça", how3_desc: "Clique em publicar — FanPush envia para todas as plataformas.",
    price_title: "Preços simples", price_sub: "Comece grátis. Faça upgrade quando quiser.",
    price_free: "Grátis", price_pro: "Pro", price_agency: "Agência", price_popular: "MAIS POPULAR",
    price_btn_free: "Começar", price_btn_pro: "Começar Pro", price_btn_agency: "Começar Agência",
    p_unlimited: "Posts ilimitados", p_5posts: "5 posts/dia", p_1plat: "1 plataforma", p_allplat: "Todas as plataformas",
    p_finder: "Buscador de Subreddits", p_antiban: "Proteção anti-ban", p_schedule: "Agendar posts", p_autodm: "Auto-DM",
    p_everything: "Tudo do Pro", p_5accounts: "5 contas de criadores", p_analytics: "Analytics avançados",
    p_support: "Suporte prioritário", p_api: "Acesso API", p_team: "Gestão de equipe",
    test_title: "Criadores amam FanPush",
    test1: '"Passei de 200 para 2.000 assinantes em 3 meses."',
    test2: '"Gastava 3 horas/dia promovendo. Agora leva 10 minutos."',
    test3: '"A publicação multi-plataforma muda tudo."',
    cta_title: "Pronto para crescer sua audiência?",
    cta_sub: "Junte-se a milhares de criadores que usam FanPush.",
    cta_placeholder: "Seu email", cta_btn: "Acesso antecipado", cta_done: "Registrado! Vamos notificá-lo no lançamento.",
    footer: "Todos os direitos reservados.",
  },
};

const FLAG: Record<string, string> = { en: "🇬🇧", fr: "🇫🇷", es: "🇪🇸", de: "🇩🇪", pt: "🇧🇷" };

const LandingPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [lang, setLang] = useState('en');
  const [langOpen, setLangOpen] = useState(false);

  const t = LANGS[lang] || LANGS.en;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen bg-gray-950 text-white overflow-hidden relative">

      {/* ── Animated background ── */}
      <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
        {/* Large moving gradient orbs */}
        <div className="absolute w-[800px] h-[800px] rounded-full blur-[150px] opacity-30" style={{
          background: 'radial-gradient(circle, #9333ea, transparent 70%)',
          top: '-10%', left: '-10%',
          animation: 'moveOrb1 20s ease-in-out infinite',
        }} />
        <div className="absolute w-[700px] h-[700px] rounded-full blur-[130px] opacity-25" style={{
          background: 'radial-gradient(circle, #ec4899, transparent 70%)',
          top: '20%', right: '-15%',
          animation: 'moveOrb2 25s ease-in-out infinite',
        }} />
        <div className="absolute w-[600px] h-[600px] rounded-full blur-[120px] opacity-20" style={{
          background: 'radial-gradient(circle, #f97316, transparent 70%)',
          bottom: '-5%', left: '30%',
          animation: 'moveOrb3 18s ease-in-out infinite',
        }} />
        <div className="absolute w-[500px] h-[500px] rounded-full blur-[100px] opacity-20" style={{
          background: 'radial-gradient(circle, #06b6d4, transparent 70%)',
          top: '50%', left: '10%',
          animation: 'moveOrb4 22s ease-in-out infinite',
        }} />
        <div className="absolute w-[400px] h-[400px] rounded-full blur-[90px] opacity-15" style={{
          background: 'radial-gradient(circle, #a855f7, transparent 70%)',
          bottom: '20%', right: '10%',
          animation: 'moveOrb5 15s ease-in-out infinite',
        }} />
        {/* Grid overlay */}
        <div className="absolute inset-0 opacity-[0.04]" style={{
          backgroundImage: 'linear-gradient(rgba(255,255,255,.15) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.15) 1px, transparent 1px)',
          backgroundSize: '80px 80px',
        }} />
        {/* Floating particles — bigger and brighter */}
        {[...Array(30)].map((_, i) => {
          const size = 2 + Math.random() * 4;
          const colors = ['#9333ea', '#ec4899', '#f97316', '#06b6d4', '#a855f7', '#22d3ee'];
          const color = colors[i % colors.length];
          return (
            <div
              key={i}
              className="absolute rounded-full"
              style={{
                width: size, height: size,
                backgroundColor: color,
                opacity: 0.3 + Math.random() * 0.3,
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animation: `float ${8 + Math.random() * 15}s ease-in-out infinite`,
                animationDelay: `${Math.random() * 8}s`,
                boxShadow: `0 0 ${size * 3}px ${color}`,
              }}
            />
          );
        })}
      </div>

      {/* ── Content (above background) ── */}
      <div className="relative z-10">

        {/* Nav */}
        <nav className="flex items-center justify-between px-6 py-4 max-w-7xl mx-auto">
          <div className="text-2xl font-bold bg-gradient-to-r from-purple-400 via-pink-400 to-orange-400 bg-clip-text text-transparent">
            FanPush
          </div>
          <div className="flex items-center gap-4">
            <a href="#pricing" className="text-gray-300 hover:text-white transition hidden sm:block">{t.nav_pricing}</a>
            <a href="#features" className="text-gray-300 hover:text-white transition hidden sm:block">{t.nav_features}</a>

            {/* Language switcher */}
            <div className="relative">
              <button
                onClick={() => setLangOpen(!langOpen)}
                className="flex items-center gap-1 bg-gray-800/50 border border-gray-700 rounded-lg px-3 py-2 text-sm hover:border-gray-500 transition"
              >
                {FLAG[lang]} {lang.toUpperCase()}
              </button>
              {langOpen && (
                <div className="absolute right-0 mt-2 bg-gray-900 border border-gray-700 rounded-lg shadow-xl overflow-hidden z-50">
                  {Object.keys(LANGS).map((l) => (
                    <button
                      key={l}
                      onClick={() => { setLang(l); setLangOpen(false); }}
                      className={`flex items-center gap-2 px-4 py-2 w-full text-left hover:bg-gray-800 transition text-sm ${l === lang ? 'bg-gray-800 text-purple-400' : 'text-gray-300'}`}
                    >
                      {FLAG[l]} {l.toUpperCase()}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <a href="/signup" className="bg-purple-600 hover:bg-purple-500 px-4 py-2 rounded-lg font-medium transition inline-block">
              {t.nav_cta}
            </a>
          </div>
        </nav>

        {/* Hero */}
        <section className="max-w-7xl mx-auto px-6 pt-20 pb-32 text-center">
          <div className="inline-block bg-purple-900/40 border border-purple-700/50 rounded-full px-4 py-1 text-sm text-purple-300 mb-6 backdrop-blur-sm">
            {t.hero_badge}
          </div>
          <h1 className="text-5xl md:text-7xl font-extrabold leading-tight mb-6">
            {t.hero_title1}<br />
            <span className="bg-gradient-to-r from-purple-400 via-pink-400 to-orange-400 bg-clip-text text-transparent">
              {t.hero_title2}
            </span>
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto mb-10">
            {t.hero_sub}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/signup" className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-500 hover:to-pink-500 px-8 py-4 rounded-xl text-lg font-bold transition shadow-lg shadow-purple-900/50 hover:shadow-purple-800/60 hover:scale-105 transform inline-block">
              {t.hero_btn1}
            </a>
            <button className="border border-gray-700 hover:border-gray-500 hover:bg-gray-900/50 px-8 py-4 rounded-xl text-lg transition backdrop-blur-sm">
              {t.hero_btn2}
            </button>
          </div>
          <p className="text-gray-500 text-sm mt-4">{t.hero_note}</p>
        </section>

        {/* ── Dashboard Preview — shows the product in action ── */}
        <section className="max-w-5xl mx-auto px-6 -mt-16 mb-20 relative z-10">
          <div className="bg-gray-900 border border-gray-700 rounded-2xl shadow-2xl shadow-purple-900/20 overflow-hidden">
            {/* Browser bar */}
            <div className="bg-gray-800 px-4 py-3 flex items-center gap-2 border-b border-gray-700">
              <div className="flex gap-1.5">
                <div className="w-3 h-3 rounded-full bg-red-500"></div>
                <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                <div className="w-3 h-3 rounded-full bg-green-500"></div>
              </div>
              <div className="flex-1 ml-4 bg-gray-700 rounded-lg px-3 py-1 text-xs text-gray-400">fanpush.io/dashboard</div>
            </div>
            {/* Dashboard mockup */}
            <div className="flex">
              {/* Sidebar */}
              <div className="w-48 bg-gray-900 border-r border-gray-800 p-4 hidden md:block">
                <div className="text-lg font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent mb-6">FanPush</div>
                {['🚀 New Post', '🎯 Subreddit Finder', '🔗 Accounts', '📊 Analytics'].map((item, i) => (
                  <div key={i} className={`px-3 py-2 rounded-lg text-sm mb-1 ${i === 0 ? 'bg-purple-600/20 text-purple-400' : 'text-gray-500'}`}>{item}</div>
                ))}
                <div className="mt-6 bg-purple-900/30 border border-purple-700/30 rounded-lg p-3">
                  <p className="text-xs text-purple-300 font-bold">Pro Plan</p>
                  <p className="text-xs text-gray-500">$14.99/mo</p>
                </div>
              </div>
              {/* Main content */}
              <div className="flex-1 p-6">
                <h3 className="text-lg font-bold mb-4">Create New Post</h3>
                {/* Platforms */}
                <div className="flex gap-2 mb-4">
                  <span className="bg-orange-500/20 border border-orange-500/50 px-3 py-1.5 rounded-lg text-sm text-orange-400">🔴 Reddit</span>
                  <span className="bg-blue-500/20 border border-blue-500/50 px-3 py-1.5 rounded-lg text-sm text-blue-400">🐦 Twitter</span>
                  <span className="bg-sky-500/20 border border-sky-500/50 px-3 py-1.5 rounded-lg text-sm text-sky-400">🦋 Bluesky</span>
                </div>
                {/* Title input */}
                <div className="bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 mb-3 text-sm text-gray-300">Check out my new content! Link in bio 🔥</div>
                {/* Subreddits */}
                <div className="flex flex-wrap gap-2 mb-4">
                  {['r/OnlyFansPromotions', 'r/curvy', 'r/FitNakedGirls', 'r/altgonewild', 'r/nsfwcosplay'].map(s => (
                    <span key={s} className="bg-gray-800 border border-gray-700 px-2 py-1 rounded-full text-xs text-gray-400">{s}</span>
                  ))}
                  <span className="text-xs text-purple-400">+12 more</span>
                </div>
                {/* Anti-ban */}
                <div className="bg-green-900/20 border border-green-700/30 rounded-lg px-4 py-2 mb-4 flex items-center gap-2">
                  <span className="text-green-400 text-sm">🛡️</span>
                  <span className="text-xs text-green-400">Anti-ban active — titles will be varied for each subreddit</span>
                </div>
                {/* Post button */}
                <div className="bg-gradient-to-r from-purple-600 to-pink-600 text-center py-3 rounded-xl font-bold text-sm">Post to 3 platforms (17 subreddits)</div>
              </div>
            </div>
          </div>
        </section>

        {/* ── Before/After — visual impact ── */}
        <section className="max-w-5xl mx-auto px-6 py-16">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">Without FanPush vs With FanPush</h2>
          <div className="grid md:grid-cols-2 gap-8">
            {/* Before */}
            <div className="bg-red-950/20 border border-red-900/30 rounded-2xl p-8">
              <div className="text-center mb-6">
                <span className="text-4xl">😩</span>
                <h3 className="text-xl font-bold mt-2 text-red-400">Without FanPush</h3>
              </div>
              <ul className="space-y-3">
                {[
                  '3+ hours/day promoting manually',
                  'Same title everywhere → shadowbanned',
                  'Only know 5-10 subreddits',
                  'Post to Reddit only',
                  'Random posting times',
                  '50-200 subscribers/month',
                ].map((item, i) => (
                  <li key={i} className="flex items-center gap-2 text-gray-400"><span className="text-red-500">✗</span> {item}</li>
                ))}
              </ul>
            </div>
            {/* After */}
            <div className="bg-green-950/20 border border-green-700/30 rounded-2xl p-8">
              <div className="text-center mb-6">
                <span className="text-4xl">🚀</span>
                <h3 className="text-xl font-bold mt-2 text-green-400">With FanPush</h3>
              </div>
              <ul className="space-y-3">
                {[
                  '10 minutes/day — automated',
                  'Auto-varied titles → zero bans',
                  '850+ subreddits matched to your niche',
                  'Reddit + Twitter + Bluesky in 1 click',
                  'Optimal posting times',
                  '500-2,000 subscribers/month',
                ].map((item, i) => (
                  <li key={i} className="flex items-center gap-2 text-gray-300"><span className="text-green-500">✓</span> {item}</li>
                ))}
              </ul>
              <a href="/signup" className="block mt-6 bg-gradient-to-r from-purple-600 to-pink-600 text-center py-3 rounded-xl font-bold hover:from-purple-500 hover:to-pink-500 transition">Start Free Now</a>
            </div>
          </div>
        </section>

        {/* ── Platform logos — "Compatible with" ── */}
        <section className="py-20 border-y border-gray-800/50 bg-gray-900/40 backdrop-blur-sm">
          <div className="max-w-7xl mx-auto px-6">
            <p className="text-center text-gray-400 text-base mb-14 uppercase tracking-widest font-medium">{t.compat_title}</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
              {/* OnlyFans */}
              <div className="group flex flex-col items-center gap-3 p-6 rounded-2xl bg-gray-800/30 border border-gray-800 hover:border-[#00AEEF]/50 hover:bg-gray-800/50 transition-all cursor-pointer hover:scale-105 transform">
                <svg width="60" height="60" viewBox="0 0 60 60">
                  <circle cx="30" cy="30" r="26" fill="none" stroke="#00AEEF" strokeWidth="4"/>
                  <circle cx="30" cy="30" r="8" fill="#00AEEF"/>
                </svg>
                <span className="text-lg font-bold text-[#00AEEF]">OnlyFans</span>
              </div>
              {/* Fansly */}
              <div className="group flex flex-col items-center gap-3 p-6 rounded-2xl bg-gray-800/30 border border-gray-800 hover:border-[#1FA2F1]/50 hover:bg-gray-800/50 transition-all cursor-pointer hover:scale-105 transform">
                <svg width="60" height="60" viewBox="0 0 60 60">
                  <rect x="5" y="5" width="50" height="50" rx="14" fill="#1FA2F1"/>
                  <text x="30" y="42" textAnchor="middle" fontFamily="Arial" fontWeight="900" fontSize="36" fill="white">f</text>
                </svg>
                <span className="text-lg font-bold text-[#1FA2F1]">Fansly</span>
              </div>
              {/* MYM */}
              <div className="group flex flex-col items-center gap-3 p-6 rounded-2xl bg-gray-800/30 border border-gray-800 hover:border-pink-500/50 hover:bg-gray-800/50 transition-all cursor-pointer hover:scale-105 transform">
                <svg width="60" height="60" viewBox="0 0 60 60">
                  <defs><linearGradient id="mym" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#FF1493"/><stop offset="100%" stopColor="#FF69B4"/></linearGradient></defs>
                  <rect x="5" y="5" width="50" height="50" rx="14" fill="url(#mym)"/>
                  <text x="30" y="40" textAnchor="middle" fontFamily="Arial" fontWeight="900" fontSize="20" fill="white">MYM</text>
                </svg>
                <span className="text-lg font-bold text-pink-400">MYM</span>
              </div>
              {/* Fanvue */}
              <div className="group flex flex-col items-center gap-3 p-6 rounded-2xl bg-gray-800/30 border border-gray-800 hover:border-orange-500/50 hover:bg-gray-800/50 transition-all cursor-pointer hover:scale-105 transform">
                <svg width="60" height="60" viewBox="0 0 60 60">
                  <defs><linearGradient id="fv" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#FF6B35"/><stop offset="100%" stopColor="#FF4500"/></linearGradient></defs>
                  <rect x="5" y="5" width="50" height="50" rx="14" fill="url(#fv)"/>
                  <text x="30" y="40" textAnchor="middle" fontFamily="Arial" fontWeight="900" fontSize="22" fill="white">FV</text>
                </svg>
                <span className="text-lg font-bold text-orange-400">Fanvue</span>
              </div>
              {/* Patreon */}
              <div className="group flex flex-col items-center gap-3 p-6 rounded-2xl bg-gray-800/30 border border-gray-800 hover:border-[#FF424D]/50 hover:bg-gray-800/50 transition-all cursor-pointer hover:scale-105 transform">
                <svg width="60" height="60" viewBox="0 0 60 60">
                  <circle cx="35" cy="22" r="14" fill="#FF424D"/>
                  <rect x="10" y="8" width="6" height="44" rx="3" fill="#FF424D"/>
                </svg>
                <span className="text-lg font-bold text-[#FF424D]">Patreon</span>
              </div>
              {/* LoyalFans */}
              <div className="group flex flex-col items-center gap-3 p-6 rounded-2xl bg-gray-800/30 border border-gray-800 hover:border-amber-500/50 hover:bg-gray-800/50 transition-all cursor-pointer hover:scale-105 transform">
                <svg width="60" height="60" viewBox="0 0 60 60">
                  <defs><linearGradient id="lf" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#F59E0B"/><stop offset="100%" stopColor="#EF4444"/></linearGradient></defs>
                  <path d="M30 8 L36 24 L52 24 L39 34 L44 50 L30 40 L16 50 L21 34 L8 24 L24 24 Z" fill="url(#lf)"/>
                </svg>
                <span className="text-lg font-bold text-amber-400">LoyalFans</span>
              </div>
              {/* Passes */}
              <div className="group flex flex-col items-center gap-3 p-6 rounded-2xl bg-gray-800/30 border border-gray-800 hover:border-emerald-500/50 hover:bg-gray-800/50 transition-all cursor-pointer hover:scale-105 transform">
                <svg width="60" height="60" viewBox="0 0 60 60">
                  <defs><linearGradient id="ps" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#10B981"/><stop offset="100%" stopColor="#06B6D4"/></linearGradient></defs>
                  <rect x="5" y="5" width="50" height="50" rx="14" fill="url(#ps)"/>
                  <path d="M20 30 L27 37 L40 22" stroke="white" strokeWidth="5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span className="text-lg font-bold text-emerald-400">Passes</span>
              </div>
              {/* ManyVids */}
              <div className="group flex flex-col items-center gap-3 p-6 rounded-2xl bg-gray-800/30 border border-gray-800 hover:border-purple-500/50 hover:bg-gray-800/50 transition-all cursor-pointer hover:scale-105 transform">
                <svg width="60" height="60" viewBox="0 0 60 60">
                  <defs><linearGradient id="mv" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#9333EA"/><stop offset="100%" stopColor="#7C3AED"/></linearGradient></defs>
                  <rect x="5" y="5" width="50" height="50" rx="14" fill="url(#mv)"/>
                  <polygon points="24,18 24,42 42,30" fill="white"/>
                </svg>
                <span className="text-lg font-bold text-purple-400">ManyVids</span>
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="bg-gray-900/30 py-12">
          <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div><div className="text-3xl font-bold text-purple-400">47K+</div><div className="text-gray-500">{t.stats_creators}</div></div>
            <div><div className="text-3xl font-bold text-pink-400">2.1M+</div><div className="text-gray-500">{t.stats_posts}</div></div>
            <div><div className="text-3xl font-bold text-orange-400">850+</div><div className="text-gray-500">{t.stats_subs}</div></div>
            <div><div className="text-3xl font-bold text-green-400">3x</div><div className="text-gray-500">{t.stats_growth}</div></div>
          </div>
        </section>

        {/* Features */}
        <section id="features" className="max-w-7xl mx-auto px-6 py-24">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-4">
            {t.feat_title} <span className="text-purple-400">{t.feat_title2}</span>
          </h2>
          <p className="text-gray-400 text-center mb-16 max-w-2xl mx-auto">{t.feat_sub}</p>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { icon: "🎯", title: t.feat1_title, desc: t.feat1_desc, color: "purple" },
              { icon: "🚀", title: t.feat2_title, desc: t.feat2_desc, color: "pink" },
              { icon: "🛡️", title: t.feat3_title, desc: t.feat3_desc, color: "orange" },
              { icon: "📊", title: t.feat4_title, desc: t.feat4_desc, color: "green" },
              { icon: "⏰", title: t.feat5_title, desc: t.feat5_desc, color: "blue" },
              { icon: "💬", title: t.feat6_title, desc: t.feat6_desc, color: "yellow" },
            ].map((f, i) => (
              <div key={i} className={`bg-gray-900/40 border border-gray-800 rounded-2xl p-8 hover:border-${f.color}-700 transition backdrop-blur-sm hover:bg-gray-900/60 group`}>
                <div className="text-4xl mb-4 group-hover:scale-110 transition-transform">{f.icon}</div>
                <h3 className="text-xl font-bold mb-2">{f.title}</h3>
                <p className="text-gray-400">{f.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* How it works */}
        <section className="bg-gray-900/20 py-24">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-3xl md:text-5xl font-bold text-center mb-16">{t.how_title}</h2>
            <div className="grid md:grid-cols-3 gap-12">
              {[
                { num: "1", color: "bg-purple-600", title: t.how1_title, desc: t.how1_desc },
                { num: "2", color: "bg-pink-600", title: t.how2_title, desc: t.how2_desc },
                { num: "3", color: "bg-orange-600", title: t.how3_title, desc: t.how3_desc },
              ].map((s, i) => (
                <div key={i} className="text-center">
                  <div className={`w-16 h-16 ${s.color} rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4 shadow-lg`}>{s.num}</div>
                  <h3 className="text-xl font-bold mb-2">{s.title}</h3>
                  <p className="text-gray-400">{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Pricing */}
        <section id="pricing" className="max-w-7xl mx-auto px-6 py-24">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-4">{t.price_title}</h2>
          <p className="text-gray-400 text-center mb-16">{t.price_sub}</p>
          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {/* Free */}
            <div className="bg-gray-900/40 border border-gray-800 rounded-2xl p-8 backdrop-blur-sm hover:border-gray-600 transition">
              <h3 className="text-xl font-bold mb-2">{t.price_free}</h3>
              <div className="text-4xl font-bold mb-4">$0<span className="text-lg text-gray-500">/mo</span></div>
              <ul className="space-y-3 text-gray-400 mb-8">
                <li className="flex items-center gap-2"><span className="text-green-400">✓</span> {t.p_5posts}</li>
                <li className="flex items-center gap-2"><span className="text-green-400">✓</span> {t.p_1plat}</li>
                <li className="flex items-center gap-2"><span className="text-green-400">✓</span> {t.p_finder}</li>
                <li className="flex items-center gap-2"><span className="text-green-400">✓</span> {t.p_antiban}</li>
                <li className="flex items-center gap-2"><span className="text-gray-600">✗</span> <span className="text-gray-600">{t.p_schedule}</span></li>
                <li className="flex items-center gap-2"><span className="text-gray-600">✗</span> <span className="text-gray-600">{t.p_autodm}</span></li>
              </ul>
              <a href="/signup" className="w-full border border-gray-700 hover:border-gray-500 py-3 rounded-xl font-medium transition block text-center">{t.price_btn_free}</a>
            </div>
            {/* Pro */}
            <div className="bg-gradient-to-b from-purple-900/40 to-gray-900/40 border-2 border-purple-500 rounded-2xl p-8 relative backdrop-blur-sm hover:border-purple-400 transition transform hover:scale-[1.02]">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-purple-600 to-pink-600 text-white text-sm font-bold px-4 py-1 rounded-full shadow-lg">
                {t.price_popular}
              </div>
              <h3 className="text-xl font-bold mb-2">{t.price_pro}</h3>
              <div className="text-4xl font-bold mb-4">$14.99<span className="text-lg text-gray-500">/mo</span></div>
              <ul className="space-y-3 text-gray-400 mb-8">
                <li className="flex items-center gap-2"><span className="text-green-400">✓</span> {t.p_unlimited}</li>
                <li className="flex items-center gap-2"><span className="text-green-400">✓</span> {t.p_allplat}</li>
                <li className="flex items-center gap-2"><span className="text-green-400">✓</span> {t.p_finder}</li>
                <li className="flex items-center gap-2"><span className="text-green-400">✓</span> {t.p_antiban}</li>
                <li className="flex items-center gap-2"><span className="text-green-400">✓</span> {t.p_schedule}</li>
                <li className="flex items-center gap-2"><span className="text-green-400">✓</span> {t.p_autodm}</li>
              </ul>
              <a href="/signup" className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-500 hover:to-pink-500 py-3 rounded-xl font-bold transition shadow-lg block text-center">{t.price_btn_pro}</a>
            </div>
            {/* Agency */}
            <div className="bg-gray-900/40 border border-gray-800 rounded-2xl p-8 backdrop-blur-sm hover:border-gray-600 transition">
              <h3 className="text-xl font-bold mb-2">{t.price_agency}</h3>
              <div className="text-4xl font-bold mb-4">$49.99<span className="text-lg text-gray-500">/mo</span></div>
              <ul className="space-y-3 text-gray-400 mb-8">
                <li className="flex items-center gap-2"><span className="text-green-400">✓</span> {t.p_everything}</li>
                <li className="flex items-center gap-2"><span className="text-green-400">✓</span> {t.p_5accounts}</li>
                <li className="flex items-center gap-2"><span className="text-green-400">✓</span> {t.p_analytics}</li>
                <li className="flex items-center gap-2"><span className="text-green-400">✓</span> {t.p_support}</li>
                <li className="flex items-center gap-2"><span className="text-green-400">✓</span> {t.p_api}</li>
                <li className="flex items-center gap-2"><span className="text-green-400">✓</span> {t.p_team}</li>
              </ul>
              <a href="/signup" className="w-full border border-gray-700 hover:border-gray-500 py-3 rounded-xl font-medium transition block text-center">{t.price_btn_agency}</a>
            </div>
          </div>
        </section>

        {/* ── Success Stories with Revenue Charts ── */}
        <section className="py-24 bg-gray-900/30">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-3xl md:text-5xl font-bold text-center mb-4">Real Results from Real Creators</h2>
            <p className="text-gray-400 text-center mb-16 max-w-2xl mx-auto">Creators using FanPush see an average 3x increase in subscribers within 90 days</p>

            <div className="grid md:grid-cols-3 gap-8 mb-16">
              {/* Creator Card 1 */}
              <div className="bg-gray-900/60 border border-gray-800 rounded-2xl overflow-hidden hover:border-purple-600/50 transition group">
                {/* Profile header */}
                <div className="bg-gradient-to-r from-purple-600/30 to-pink-600/30 p-6">
                  <div className="flex items-center gap-4">
                    <img src="https://randomuser.me/api/portraits/women/70.jpg" alt="Sarah M." className="w-16 h-16 rounded-full object-cover shadow-lg border-2 border-purple-500"/>
                    <div>
                      <div className="font-bold text-lg">Sarah M.</div>
                      <div className="text-purple-300 text-sm">OnlyFans • Fitness</div>
                    </div>
                  </div>
                </div>
                {/* Stats */}
                <div className="p-6">
                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div className="text-center"><div className="text-2xl font-bold text-green-400">+312%</div><div className="text-xs text-gray-500">Subscriber growth</div></div>
                    <div className="text-center"><div className="text-2xl font-bold text-purple-400">$4.2K</div><div className="text-xs text-gray-500">Monthly revenue</div></div>
                  </div>
                  {/* Revenue chart SVG */}
                  <svg viewBox="0 0 200 60" className="w-full h-16 mt-2">
                    <defs><linearGradient id="g1" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" stopColor="#a855f7" stopOpacity="0.3"/><stop offset="100%" stopColor="#a855f7" stopOpacity="0"/></linearGradient></defs>
                    <path d="M0,55 L20,50 L40,48 L60,45 L80,40 L100,32 L120,25 L140,18 L160,12 L180,8 L200,5" stroke="#a855f7" strokeWidth="2" fill="none"/>
                    <path d="M0,55 L20,50 L40,48 L60,45 L80,40 L100,32 L120,25 L140,18 L160,12 L180,8 L200,5 L200,60 L0,60 Z" fill="url(#g1)"/>
                  </svg>
                  <div className="flex justify-between text-xs text-gray-600 mt-1"><span>Jan</span><span>Mar</span><span>Jun</span><span>Now</span></div>
                  <p className="text-sm text-gray-400 mt-4 italic">"FanPush found me subreddits I never knew existed. 3x subscribers in 3 months."</p>
                </div>
              </div>

              {/* Creator Card 2 */}
              <div className="bg-gray-900/60 border border-gray-800 rounded-2xl overflow-hidden hover:border-pink-600/50 transition group">
                <div className="bg-gradient-to-r from-pink-600/30 to-orange-600/30 p-6">
                  <div className="flex items-center gap-4">
                    <img src="https://randomuser.me/api/portraits/women/41.jpg" alt="Jessica R." className="w-16 h-16 rounded-full object-cover shadow-lg border-2 border-pink-500"/>
                    <div>
                      <div className="font-bold text-lg">Jessica R.</div>
                      <div className="text-pink-300 text-sm">Fansly • Cosplay</div>
                    </div>
                  </div>
                </div>
                <div className="p-6">
                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div className="text-center"><div className="text-2xl font-bold text-green-400">+580%</div><div className="text-xs text-gray-500">Subscriber growth</div></div>
                    <div className="text-center"><div className="text-2xl font-bold text-pink-400">$7.8K</div><div className="text-xs text-gray-500">Monthly revenue</div></div>
                  </div>
                  <svg viewBox="0 0 200 60" className="w-full h-16 mt-2">
                    <defs><linearGradient id="g2" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" stopColor="#ec4899" stopOpacity="0.3"/><stop offset="100%" stopColor="#ec4899" stopOpacity="0"/></linearGradient></defs>
                    <path d="M0,55 L20,53 L40,50 L60,48 L80,42 L100,35 L120,20 L140,12 L160,8 L180,5 L200,3" stroke="#ec4899" strokeWidth="2" fill="none"/>
                    <path d="M0,55 L20,53 L40,50 L60,48 L80,42 L100,35 L120,20 L140,12 L160,8 L180,5 L200,3 L200,60 L0,60 Z" fill="url(#g2)"/>
                  </svg>
                  <div className="flex justify-between text-xs text-gray-600 mt-1"><span>Jan</span><span>Mar</span><span>Jun</span><span>Now</span></div>
                  <p className="text-sm text-gray-400 mt-4 italic">"From 200 to 2,000 subs. The anti-ban feature saved my Reddit account."</p>
                </div>
              </div>

              {/* Creator Card 3 */}
              <div className="bg-gray-900/60 border border-gray-800 rounded-2xl overflow-hidden hover:border-orange-600/50 transition group">
                <div className="bg-gradient-to-r from-orange-600/30 to-yellow-600/30 p-6">
                  <div className="flex items-center gap-4">
                    <img src="https://randomuser.me/api/portraits/women/68.jpg" alt="Mia K." className="w-16 h-16 rounded-full object-cover shadow-lg border-2 border-orange-500"/>
                    <div>
                      <div className="font-bold text-lg">Mia K.</div>
                      <div className="text-orange-300 text-sm">MYM • Alt/Tattoo</div>
                    </div>
                  </div>
                </div>
                <div className="p-6">
                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div className="text-center"><div className="text-2xl font-bold text-green-400">+210%</div><div className="text-xs text-gray-500">Subscriber growth</div></div>
                    <div className="text-center"><div className="text-2xl font-bold text-orange-400">$2.9K</div><div className="text-xs text-gray-500">Monthly revenue</div></div>
                  </div>
                  <svg viewBox="0 0 200 60" className="w-full h-16 mt-2">
                    <defs><linearGradient id="g3" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" stopColor="#f97316" stopOpacity="0.3"/><stop offset="100%" stopColor="#f97316" stopOpacity="0"/></linearGradient></defs>
                    <path d="M0,55 L20,52 L40,48 L60,44 L80,38 L100,33 L120,28 L140,22 L160,18 L180,15 L200,10" stroke="#f97316" strokeWidth="2" fill="none"/>
                    <path d="M0,55 L20,52 L40,48 L60,44 L80,38 L100,33 L120,28 L140,22 L160,18 L180,15 L200,10 L200,60 L0,60 Z" fill="url(#g3)"/>
                  </svg>
                  <div className="flex justify-between text-xs text-gray-600 mt-1"><span>Jan</span><span>Mar</span><span>Jun</span><span>Now</span></div>
                  <p className="text-sm text-gray-400 mt-4 italic">"Multi-platform posting changed everything. One click and I'm everywhere."</p>
                </div>
              </div>
            </div>

            {/* Big stat banner */}
            <div className="bg-gradient-to-r from-purple-900/40 via-pink-900/40 to-orange-900/40 border border-purple-700/30 rounded-2xl p-8 text-center">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                <div><div className="text-4xl font-bold text-white">3x</div><div className="text-gray-400 text-sm">Average subscriber growth</div></div>
                <div><div className="text-4xl font-bold text-white">10 min</div><div className="text-gray-400 text-sm">vs 3 hours manual promotion</div></div>
                <div><div className="text-4xl font-bold text-white">0</div><div className="text-gray-400 text-sm">Shadowbans with anti-ban</div></div>
                <div><div className="text-4xl font-bold text-white">850+</div><div className="text-gray-400 text-sm">NSFW subreddits in database</div></div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="py-24">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-3xl md:text-5xl font-bold text-center mb-16">{t.test_title}</h2>
            <div className="grid md:grid-cols-3 gap-8">
              {[
                { text: t.test1, name: "Sarah M.", role: "OnlyFans Creator", color: "bg-purple-600" },
                { text: t.test2, name: "Jessica R.", role: "Fansly Creator", color: "bg-pink-600" },
                { text: t.test3, name: "Mia K.", role: "MYM Creator", color: "bg-orange-600" },
              ].map((test, i) => (
                <div key={i} className="bg-gray-900/40 border border-gray-800 rounded-2xl p-8 backdrop-blur-sm hover:border-gray-700 transition">
                  <div className="flex mb-3">{[...Array(5)].map((_, j) => <span key={j} className="text-yellow-400">★</span>)}</div>
                  <p className="text-gray-300 mb-4 italic">{test.text}</p>
                  <div className="flex items-center gap-3">
                    <div className={`w-10 h-10 ${test.color} rounded-full flex items-center justify-center font-bold`}>{test.name[0]}</div>
                    <div><div className="font-bold">{test.name}</div><div className="text-gray-500 text-sm">{test.role}</div></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="max-w-7xl mx-auto px-6 py-24 text-center">
          <h2 className="text-3xl md:text-5xl font-bold mb-6">{t.cta_title}</h2>
          <p className="text-gray-400 text-xl mb-10 max-w-xl mx-auto">{t.cta_sub}</p>
          {!submitted ? (
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 justify-center max-w-lg mx-auto">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t.cta_placeholder}
                className="flex-1 px-6 py-4 bg-gray-900/50 border border-gray-700 rounded-xl text-white placeholder-gray-500 focus:border-purple-500 focus:outline-none backdrop-blur-sm"
                required
              />
              <button type="submit" className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-500 hover:to-pink-500 px-8 py-4 rounded-xl font-bold transition shadow-lg hover:scale-105 transform">
                {t.cta_btn}
              </button>
            </form>
          ) : (
            <div className="bg-green-900/30 border border-green-700 rounded-xl px-8 py-4 inline-block backdrop-blur-sm">
              <span className="text-green-400 font-bold">{t.cta_done}</span>
            </div>
          )}
        </section>

        {/* Footer */}
        <footer className="border-t border-gray-800 py-8">
          <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-gray-500">&copy; 2026 FanPush. {t.footer}</div>
            <div className="flex gap-6 text-gray-500">
              <span className="hover:text-white transition cursor-pointer">Privacy</span>
              <span className="hover:text-white transition cursor-pointer">Terms</span>
              <span className="hover:text-white transition cursor-pointer">Contact</span>
            </div>
          </div>
        </footer>
      </div>

      {/* ── CSS animations ── */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0) translateX(0); }
          25% { transform: translateY(-30px) translateX(15px); }
          50% { transform: translateY(-15px) translateX(-20px); }
          75% { transform: translateY(-40px) translateX(10px); }
        }
        @keyframes moveOrb1 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(100px, 50px) scale(1.1); }
          66% { transform: translate(-50px, 100px) scale(0.9); }
        }
        @keyframes moveOrb2 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(-80px, 60px) scale(1.15); }
          66% { transform: translate(60px, -40px) scale(0.85); }
        }
        @keyframes moveOrb3 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(70px, -80px) scale(1.1); }
          66% { transform: translate(-100px, 30px) scale(0.95); }
        }
        @keyframes moveOrb4 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(-60px, -70px) scale(1.2); }
          66% { transform: translate(80px, 50px) scale(0.9); }
        }
        @keyframes moveOrb5 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(90px, -60px) scale(1.15); }
        }
      `}</style>
    </div>
  );
};

export default LandingPage;
